import React from 'react';

//libs
import MetaTags from 'react-meta-tags';
import {
  Alert,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
  Spinner,
} from 'reactstrap';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';

// components
import ParticlesAuth from '../../components/ParticlesAuth';

const variants = {
  open: { height: 0, opacity: 0 },
  closed: { height: 60, opacity: 1 },
};

export const LoginPage = (props) => {
  const { validation, error, loading } = props;

  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className="auth-page-content">
          <MetaTags>
            <title>Login | {process.env.REACT_APP_TITLE}</title>
          </MetaTags>
          <Container>
            <Row>
              <Col lg={12}>
                <div className="text-center mt-sm-5 mb-4 text-white-50">
                  <div>
                    <Link to="/" className="d-inline-block auth-logo"></Link>
                  </div>
                </div>
              </Col>
            </Row>

            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card
                  className="mt-4"
                  style={{
                    transition: 'height 2s',
                  }}
                >
                  <CardBody
                    className="p-4"
                    style={{
                      overflow: 'hidden',
                      transition: 'height 5s',
                    }}
                  >
                    <div
                      style={{
                        width: '250px',
                        height: '100px',
                        overflow: 'hidden',
                        position: 'relative',
                        margin: '0 auto',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <img
                        src={process.env.REACT_APP_LOGO_LOGIN}
                        alt="logo-login"
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                        }}
                      />
                    </div>

                    <div className="text-center mt-2">
                      <h5 className="text-primary">Acesse sua conta</h5>
                      <span className="text-muted">
                        Informe suas credenciais de acesso
                      </span>
                    </div>

                    {error && (
                      <motion.nav
                        animate={!error ? 'open' : 'closed'}
                        variants={variants}
                      >
                        <div data-aos="fade-down">
                          <Alert color="danger" className="mb-0">
                            <strong> Erro de autenticação! </strong>
                            {error}
                          </Alert>
                        </div>
                      </motion.nav>
                    )}

                    <div className="p-2 mt-2">
                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                        action="#"
                      >
                        <div className="mb-3">
                          <Label htmlFor="username" className="form-label">
                            Usuário
                          </Label>
                          <Input
                            tabIndex={1}
                            name="username"
                            className="form-control"
                            placeholder="Digite seu usuário"
                            type="username"
                            onChange={(e) => {
                              validation.handleChange(e);
                            }}
                            value={validation.values.username || ''}
                            invalid={
                              !!(
                                validation.touched.username &&
                                validation.errors.username
                              )
                            }
                          />
                          {validation.touched.username &&
                          validation.errors.username ? (
                            <FormFeedback type="invalid">
                              {validation.errors.username}
                            </FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-3">
                          <div className="float-end">
                            <Link to="/forgot-password" className="text-muted">
                              Esqueceu sua senha?
                            </Link>
                          </div>
                          <Label
                            className="form-label"
                            htmlFor="password-input"
                          >
                            Senha
                          </Label>
                          <div className="position-relative auth-pass-inputgroup mb-3">
                            <Input
                              tabIndex={2}
                              name="password"
                              value={validation.values.password || ''}
                              type={props.showPassword ? 'text' : 'password'}
                              className="form-control pe-5"
                              placeholder="Digite sua senha"
                              onChange={validation.handleChange}
                              invalid={
                                !!(
                                  validation.touched.password &&
                                  validation.errors.password
                                )
                              }
                            />
                            {validation.touched.password &&
                            validation.errors.password ? (
                              <FormFeedback type="invalid">
                                {validation.errors.password}
                              </FormFeedback>
                            ) : null}
                            <button
                              className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted shadow-none"
                              type="button"
                              id="password-addon"
                              onClick={() => props.toggleShowPassword()}
                            >
                              <i className="ri-eye-fill align-middle"></i>
                            </button>
                          </div>
                        </div>

                        <div className="form-check">
                          <Input
                            id="rememberMe"
                            className="form-check-input"
                            type="checkbox"
                            value={validation.values.rememberMe || ''}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            defaultChecked={validation.values.rememberMe}
                            invalid={
                              !!(
                                validation.touched.rememberMe &&
                                validation.errors.rememberMe
                              )
                            }
                          />
                          <Label
                            className="form-check-label"
                            htmlFor="auth-remember-check"
                          >
                            Lembrar de mim
                          </Label>
                        </div>

                        <div className="mt-4">
                          <Button
                            color="primary"
                            className="btn w-100"
                            type="submit"
                            tabIndex={3}
                          >
                            {loading ? (
                              <Spinner color="light" type="grow" size={'sm'}>
                                Carregando...
                              </Spinner>
                            ) : (
                              'Entrar'
                            )}
                          </Button>
                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </ParticlesAuth>
    </React.Fragment>
  );
};

LoginPage.propTypes = {
  validation: PropTypes.object.isRequired,
  remenberMe: PropTypes.bool,
  error: PropTypes.string,
  loading: PropTypes.bool,
};

LoginPage.defaultProps = {
  validation: null,
  loading: false,
};
